import Product from '../components/Product';

export default class ProductSection {
  constructor(section) {
    this.product = new Product(section.el, section.data);
  }

  onSectionUnload() {
    return this.product.unload();
  }
}
